import { combineReducers } from 'redux';
import * as signUpActions from 'stash/actions/signUp';
import {
	GRAPHQL_GET_CART_ITEMS_SUCCESS,
	SET_MULTI_AUTOSTASH,
	SET_ONE_TIME_TRANSFER,
} from 'stash/actions';

import multiFunding from './multiFunding';
import theme from './theme';

export const initCompletedState = {};

export const completed = (state = initCompletedState, action) => {
	switch (action.type) {
		case signUpActions.SET_PROGRESS_STEP:
		case signUpActions.SET_STASH_PLAN_FEE_WAIVER:
		case signUpActions.SET_EMPLOYED:
		case signUpActions.SET_AUTO_INVEST_MIX:
		case signUpActions.SKIP_TO_LINK_BANK_PRIMER:
		case signUpActions.SET_LINK_BANK_PRIMER_COMPLETE:
		case signUpActions.SET_LINK_BANK_LATER:
		case signUpActions.SET_SKIP_BANK_LINK:
		case signUpActions.SET_CONFIRM_TRANSFER:
		case signUpActions.SET_TRANSFER_COMPLETE:
		case signUpActions.SET_COMPLETED_REFERRAL:
		case signUpActions.SET_BILLING_SUMMARY:
		case signUpActions.SET_BILLING_FREQUENCY:
		case signUpActions.SET_ONE_TIME_TRANSFER_VALUE_PROP:
		case signUpActions.SET_ONE_TIME_TRANSFER_COMPLETE:
		case signUpActions.SET_ONE_TIME_TRANSFER_SKIP:
		case signUpActions.SET_ONE_TIME_TRANSFER_CONFIRM:
		case signUpActions.SET_RECURRING_TRANSFER_VALUE_PROP:
		case signUpActions.SET_RECURRING_TRANSFER:
		case signUpActions.SET_RECURRING_TRANSFER_CONFIRM:
		case signUpActions.SET_RECURRING_TRANSFER_SKIP:
		case signUpActions.SET_EXPLORE_ADVICE_COMPLETE:
		case signUpActions.SET_ADD_TRUSTED_CONTACT:
		case signUpActions.SET_WELCOME_TO_STASH_COMPLETE:
		case signUpActions.SET_BANK_LINK_OAUTH:
		case signUpActions.SET_SCHEDULE_COMPLETE:
		case signUpActions.SET_AUTO_INVEST_SMART_SUMMARY_COMPLETE:
		case signUpActions.SET_SMART_PORTFOLIO_TRANSITION_COMPLETE:
		case signUpActions.SET_SMART_PORTFOLIO_ALLOCATION_COMPLETE:
		case signUpActions.SET_ADD_CASH:
		case signUpActions.SET_ADD_CASH_AMOUNT_COMPLETE:
		case signUpActions.SET_AUTO_INVEST_ADD_CASH_SUMMARY_COMPLETE:
		case signUpActions.SET_ADD_CASH_SUCCESS_COMPLETE:
		case signUpActions.SET_DUPLICATE_SSN_BLOCK_SCREEN:
		case signUpActions.SET_VALID_SSN_COMPLETE:
		case signUpActions.SET_STATE_ZERO_HOME_COMPLETE:
		case signUpActions.SET_STATE_ZERO_PRIMER_COMPLETE:
		case signUpActions.SET_IDV_CHECK_LOADER_COMPLETE:
		case signUpActions.SET_IDV_SUCCESS_COMPLETE:
		case signUpActions.SET_SMART_SUCCESS_COMPLETE:
		case signUpActions.SET_ONBOARDING_COMPLETE:
			return {
				...state,
				[action.name]: action.value,
			};

		default:
			return state;
	}
};

export const initDataState = {};

const data = (state = initDataState, action) => {
	switch (action.type) {
		case signUpActions.SET_SIGN_UP_ACCOUNT_TYPE:
			return {
				...state,
				...action.data,
			};
		case SET_MULTI_AUTOSTASH:
			return {
				...state,
				auto_stash: action.data,
			};
		default:
			return state;
	}
};

export const initFirstPurchaseState = {};

export const firstPurchase = (state = initFirstPurchaseState, action) => {
	switch (action.type) {
		case GRAPHQL_GET_CART_ITEMS_SUCCESS: {
			const cartItems = action.response?.cart_items_with_cards || [{}];
			const cartItem = cartItems[0];

			return {
				...state,
				...cartItem,
			};
		}

		default:
			return state;
	}
};

export const initialOneTimeTransferState = {
	amount: '50',
	frequency: 'oneTime',
	eligibleForPlasticFunding: false,
};

const oneTimeTransfer = (state = initialOneTimeTransferState, action) => {
	switch (action.type) {
		case SET_ONE_TIME_TRANSFER:
			return {
				...state,
				amount: action.amount,
			};
		default:
			return state;
	}
};

export default combineReducers({
	completed,
	data,
	firstPurchase,
	multiFunding,
	oneTimeTransfer,
	theme,
});
